// src/pages/QuestionList.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useAuth } from '../components/AuthContext';
import Layout from '../components/Layout';
import Login from '../components/Login';
import './QuestionList.css'; // Create this CSS file

function QuestionList() {
    const [questions, setQuestions] = useState([]);
    const { currentUser, setAuthError } = useAuth();
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://127.0.0.1:5000/api';

    useEffect(() => {
        const fetchQuestions = async () => {
            if (currentUser) {
                try {
                    const idToken = await currentUser.getIdToken();
                    const response = await axios.get(`${backendUrl}/all-questions`, {
                        headers: {
                            'Authorization': `Bearer ${idToken}`
                        }
                    });
                    setQuestions(response.data);
                    setAuthError(null);
                } catch (error) {
                    if (error.response && error.response.status === 403 && error.response.data.error === 'Unauthorized Access') {
                        // This is our specific backend authorization error
                        setAuthError(error.response.data.message);
                    } else {
                        console.error("Error fetching questions:", error);
                        setAuthError("An unexpected error occurred while fetching questions.");
                    }
                    console.error("Error fetching questions:", error);
                }
            } else {
                setAuthError(null); // Clear error if not logged in
                setQuestions([]); // Clear videos if logged out
            }
        };

        fetchQuestions();
    }, [currentUser]);

    if (!currentUser) {
        return (
            <div className="question-list-container">
                <Login className="login-button" />
            </div>
        );
    }

    return (
        <Layout>
            <div className="question-list-container">
                <h1 className="question-list-heading">Questions</h1>
                <div>
                    <ul className="question-list">
                        {questions.map(question => (
                            <li key={question.id} className="question-item">
                                <Link to={`/compare?questionId=${encodeURIComponent(question.id)}`} className="question-link">
                                    {question.text}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </Layout>
    );
}

export default QuestionList;